import { ChangeEmailDialogComponent } from './../../dialogs/change-email-dialog/change-email-dialog.component';
import { OwnersService } from './../../services/owners.service';
import { getOwnerName, getOwnerPerson, Owner } from './../../models/owner.model';
import { ErrorResponse } from './../../models/error.model';
import { PageEvent } from '@angular/material/paginator';
import { UtilsService } from './../../services/utils.service';
import { PaginatorStatus, DataTableColumn, SortConfiguration } from './../generics/data-table/data-table.component';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CustomTableFilter } from '../generics/table-filter/table-filter.component';
import { UserType } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-owners',
  templateUrl: './owners.component.html',
  styleUrls: ['./owners.component.scss']
})
export class OwnersComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Código', prop: 'codigo', sortable: true },
        { name: 'Tipo de persona', prop: 'tipoPersona', sortable: true },
        { name: 'Nombre / Razón social', parseValue: (owner: Owner) => getOwnerName(owner) },
        { name: 'E-Mail', prop: 'email', sortable: true, type: 'email' },
        { name: 'DNI', prop: 'personaFisica.dni', sortable: true },
        { name: 'CUIT', prop: 'personaJuridica.cuit', type: 'cuit', sortable: true },
        { name: 'Teléfono', parseValue: (owner: Owner) => this.utilsService.parseByType(getOwnerPerson(owner).celular, 'phone') },
        { name: '', width: '180px' }
    ];

    sortConfiguration?: SortConfiguration;

    owners: Owner[];

    filters: CustomTableFilter[] = [
        { key: 'codigo', description: 'Código', type: 'STRING' },
        { key: 'personaFisica-nombre', description: 'Nombre', type: 'STRING' },
        { key: 'personaFisica-apellido', description: 'Apellido', type: 'STRING' },
        { key: 'personaJuridica-razonSocial', description: 'Razón social', type: 'STRING' },
        { key: 'personaFisica-dni', description: 'DNI', type: 'STRING' },
        { key: 'personaJuridica-cuit', description: 'CUIT', type: 'STRING' },
        { key: 'email', description: 'Email', type: 'STRING' },
    ];
    filterValues: any = {};

    userType?: UserType;

    constructor(
        private ownersService: OwnersService,
        private authService: AuthService,
        private dialog: MatDialog,
        private utilsService: UtilsService
    ) {}

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getOwners();
        this.userType = this.authService.getUser()?.tipo;
        if (this.userType !== 'AGENTE') {
            this.columns[this.columns.length - 1].width = '70px';
        }
    }

    getOwners() {
        this.ownersService.getOwners(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], this.filterValues)
        .subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.owners = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener propietarios', error.error?.descripcion));
    }

    updateOwners(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getOwners();
    }

    updateSort(event: SortConfiguration | undefined) {
        this.sortConfiguration = event;
        this.getOwners();
    }

    deleteOwner(owner: Owner) {
        const dialog = this.utilsService.confirm('¿Está seguro?', 'Esta acción no se puede deshacer.');
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.ownersService.deleteOwner(owner.id).subscribe(_ => {
                    this.utilsService.alert('Propietario borrado correctamente', `Se ha eliminado el propetario ${getOwnerName(owner)} de la plataforma.`);
                    this.getOwners();
                }, (error: ErrorResponse) => this.utilsService.alert('Error al borrar propietario', error.error?.descripcion));
            }
        });
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getOwners();
    }

    resetUserPassword(owner: Owner) {
        const alert = this.utilsService.confirm('¿Está seguro?', 'Se enviará un email al dueño de la cuenta para generar una nueva contraseña, esta acción no se puede deshacer.');
        alert.afterClosed().subscribe(result => {
            if (result) {
                this.authService.requestRecovery(owner.email, 'PROPIETARIO').subscribe({
                    next: _ => this.utilsService.alert('Contraseña regenerada correctamente', 'Se ha enviado un email al email registrado con la nueva clave.'),
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al regenerar clave', error.error?.descripcion)
                });
            }
        });
    }

    changeEmail(owner: Owner) {
        this.dialog.open(ChangeEmailDialogComponent, { data: { email: owner.email } })
            .afterClosed().subscribe(result => {
                if (result) {
                    this.getOwners();
                }
            });
    }
}
